import React, { useEffect, useMemo } from "react";
import PropTypes from "prop-types";
import { Select } from "antd";

import { useGetProjectList } from "../../../hooks/project.hooks";

const { Option } = Select;

const ProjectSelect = (props) => {
  const { hmgId, value, onChange, setProjectListRef, solution, ...otherProps } = props;
  const { data: projectList, isLoading } = useGetProjectList();
  useEffect(() => {
    onChange(undefined);
  }, [hmgId]);

  const filteredProjectList = useMemo(() => {
    return hmgId && Array.isArray(projectList)
      ? projectList.filter((project) =>
          solution
            ? project.hmg_id === hmgId && project.solution === solution
            : project.hmg_id === hmgId,
        )
      : [];
  }, [hmgId, projectList]);

  useEffect(() => {
    if (setProjectListRef !== undefined) {
      setProjectListRef(filteredProjectList);
    }
  }, [filteredProjectList]);

  return (
    <Select
      placeholder="Project"
      showSearch
      loading={isLoading}
      filterOption={(input, option) => {
        return option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }}
      value={value}
      onChange={onChange}
      {...otherProps}
    >
      {filteredProjectList.map((project) => (
        <Option value={project._id} key={project._id}>
          {project.project_name}
        </Option>
      ))}
    </Select>
  );
};

ProjectSelect.defaultProps = {
  hmgId: undefined,
  value: undefined,
  solution: undefined,
  setProjectListRef: undefined,
};

ProjectSelect.propTypes = {
  hmgId: PropTypes.string,
  value: PropTypes.string,
  solution: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  setProjectListRef: PropTypes.func,
};

export default ProjectSelect;
